export const phone_lists = {
  modal: {
    remove: {
      content: `Are you sure you want to delete the list <b>{name}<b>?`
    }
  },

  form: {
    title: {
      edit: {
        main: 'Number List Data',
        add_phone: 'Add numbers',
        added_phones: 'Added numbers'
      }
    },

    state: {
      add: 'Added',
      remove: 'Remove'
    },

    field: {
      name: 'Name',
      phone: 'Number',
      state: 'State'
    }
  }
};
